const Warning = ({
  width = '24',
  height = '24',
  className = '',
  title = '',
  stroke = '1.5',
  role = '',
  filled = false
}): React.ReactNode => {
  const hidden = title && title.length > 0 ? false : true;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      stroke="#000000"
      aria-hidden={`${hidden}`}
      role={role ? role : hidden ? 'graphics-document' : 'img'}
    >
      {!hidden && <title>{title}</title>}
      <path
        d="M13.3508 3.46672C13.2268 3.21422 13.0345 3.00155 12.7957 2.85282C12.557 2.70408 12.2813 2.62524 12 2.62524C11.7187 2.62524 11.443 2.70408 11.2042 2.85282C10.9655 3.00155 10.7732 3.21422 10.6492 3.46672L2.75501 19.5484C2.65998 19.7417 2.61579 19.956 2.6266 20.1711C2.63741 20.3863 2.70286 20.5951 2.81678 20.7779C2.9307 20.9607 3.08933 21.1115 3.2777 21.216C3.46606 21.3205 3.67794 21.3752 3.89334 21.375H20.1067C20.3221 21.3752 20.5339 21.3205 20.7223 21.216C20.9107 21.1115 21.0693 20.9607 21.1832 20.7779C21.2972 20.5951 21.3626 20.3863 21.3734 20.1711C21.3842 19.956 21.34 19.7417 21.245 19.5484L13.3508 3.46672Z"
        stroke={filled ? 'transparent' : 'currentColor'}
        fill={filled ? '#816E09' : 'none'}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 18.25C11.8274 18.25 11.6875 18.1101 11.6875 17.9375C11.6875 17.7649 11.8274 17.625 12 17.625"
        stroke={filled ? 'white' : 'currentColor'}
        strokeWidth={stroke}
      />
      <path
        d="M12 18.25C12.1726 18.25 12.3125 18.1101 12.3125 17.9375C12.3125 17.7649 12.1726 17.625 12 17.625"
        stroke={filled ? 'white' : 'currentColor'}
        strokeWidth={stroke}
      />
      <path
        d="M12 15.125V8.875"
        stroke={filled ? 'white' : 'currentColor'}
        strokeWidth={stroke}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Warning;
